import React from 'react';

const Header = (props) => {
   return (
      <header className="top">
         <img src="/images/logo.jpg" alt="Daisy Mae's Logo" />
         <p>{props.copy}</p>

         {/* <p>Follow us on Facebook <a href="http://www.facebook.com/RealDaisyMaeBBQ">www.facebook.com/RealDaisyMaeBBQ</a></p>

         <p>Thanks for your support.</p>

         <p>If you have any questions please email us at daisymaebbq@gmail.com.</p> */}
      </header>
   )
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js